export default "__VITE_ASSET__vf4nhdUo__"